<router-outlet (click)="this.userInteracted=true"></router-outlet>

